import { getGraphqlClient } from "@/api/graphql/client.ts";

import { fromApiToTidLinkedAccountTypes } from "./mappers.ts";
import { SearchTidLinkedAccountTypesQuery } from "./queries.ts";

export const getTidLinkedAccountTypes = async () => {
  const graphqlClient = getGraphqlClient();

  const response = await graphqlClient.request(
    SearchTidLinkedAccountTypesQuery,
    { request: {} },
  );

  return fromApiToTidLinkedAccountTypes(response);
};
